import { userAvatar } from 'Services/avatarGenerator'

/**
 * @param {ApiCompanyFaqAnswer} answer
 */
export const parseAnswer = (answer) => {
  const info = {
    question: answer.questionTitle,
    answer: answer.answerDescription,
    url: answer.questionUrl,
    asked: `há ${answer.questionDateCreated}`,
    answered: `há ${answer.answerDateCreated}`,
  }

  const author = {
    name: answer.authorName,
    avatar: userAvatar(answer.authorImageUrl, answer.authorName),
    url: null,
  }

  return { author, ...info }
}

/**
 * @param {ApiCompanyFaqQuestion} data
 */
export const parseAnswerList = (data) => {
  return data.answers.map(parseAnswer)
}

export default {
  parseAnswer,
  parseAnswerList,
}